export const maxSizeMBValidator =
    (mb: number) =>
    (file: File): Error | null =>
        // FIXME: translate the error message since it's user-facing
        file.size > mb * 1024 * 1024 ? new Error(`File is too large (max ${mb}MB)`) : null;
